// extracted by mini-css-extract-plugin
export default {"container":"dF-z","disabled":"eF-z","bgBlack":"fF-z","content":"gF-z","countdown":"hF-z","topCaption":"iF-z","topHeading":"jF-z","heading":"kF-z","copy":"lF-z"};